import { getWorker } from "./worker-injector";
const displayWorkerLog: boolean = (process.env.SHOW_WORKER_LOG?.toLowerCase() === 'true') || false;

// Log utility for worker-related messages
function logWorkerMessage(message: string, color: string) {
    if (displayWorkerLog) {
        console.log(`%c[DOMWorker]%c ${message}`, `background:${color}; color:#f3f3f3; font-weight: bold; padding: 0 8px`, '');
    }
}
// Helper to send a request and wait for a response
function sendWorkerMessage(type: string, payload?: any): Promise<any> {

  return new Promise((resolve, reject) => {
    (async () => {
    if (!('Worker' in window)) {
        logWorkerMessage('Web Workers are not supported in this environment.', 'red');
        resolve(null);
        return;
        }
      let worker;
      try {
        worker = await getWorker();
      } catch (error) {
        logWorkerMessage(`Failed to get worker: ${error instanceof Error ? error.message : JSON.stringify(error) ?? "Unknown error"}`, 'red');
        return reject(new Error("Incognito mode or Worker unavailable."));
      }
     if (!worker) {
        logWorkerMessage('Worker is not available (possibly in incognito mode).', 'red');
        resolve(null);
        return;
      }
    logWorkerMessage('Registering domTemplateServiceWorker...', 'blue');

      worker.onmessage = (event) => {
        const { type } = event.data;
        const rest = { ...event.data };
        delete rest.type;
        if (type.endsWith('_RESULT')) {
          resolve(rest);
          worker.terminate();
          logWorkerMessage('Worker response received.', 'green');
        } else if (type === 'ERROR') {
          reject(new Error(rest.error ?? "Unknown worker error"));
          logWorkerMessage(`Worker error: ${rest.error ?? "Unknown error"}`, 'red');
          worker.terminate();
        }
      };
      worker.onerror = (err) => {
        reject(new Error(err?.message ?? JSON.stringify(err)));
        worker.terminate();
        logWorkerMessage(`Worker error: ${err?.message ?? JSON.stringify(err)}`, 'red');
      };
      worker.postMessage({ type, payload });
    })();
  });
}

// API functions
export function lookupTemplate(key: string, hashedValue?: string) {
  return sendWorkerMessage('LOOKUP', { key, hashedValue });
}
export function insertTemplate(key: string, value: any) {
  return sendWorkerMessage('INSERT', { key, value });
}
export function deleteTemplate(key: string) {
  return sendWorkerMessage('DELETE', { key });
}
export function checkWorkerIncognito() {
  return sendWorkerMessage('CHECK_INCOGNITO');
}